import {formatDate, formatDocumentOrganizationUnit} from "utils/valueFormatter.function";
import type {DocumentDetailsProps} from "types/documentData";
import {DocumentDataField, DocumentDataGrid} from "./DocumentDataField.component";
import {DocumentAmountField} from "./DocumentAmount.component";
import {CostUnitsDetails} from "./CostUnitsDetails.component";
import {getDisplayId} from "./documentData.function";

const PurchaseOrderDocumentDetailsDTO = ({details, translate}: DocumentDetailsProps) => (
    <>
        <DocumentDataGrid>
            {details.description &&
                <DocumentDataField id="description" wide label={translate("documentData.description")}
                                   value={details.description}/>}
            {details.claimant &&
                <DocumentDataField id="claimant" label={translate("documentData.requester")} value={details.claimant}/>}
            {!!details.costRequestDate &&
                <DocumentDataField id="costRequestDate" label={translate("documentData.expenseDate")}
                                   value={formatDate(details.costRequestDate, null)}/>}
            <DocumentDataField id="documentId" label={translate("documentData.documentID")} value={getDisplayId(details)}/>
            {details.supplierName &&
                <DocumentDataField id="supplierName" label={translate("documentData.supplierName")}
                                   value={details.supplierName}/>}
            {details.supplierNumber &&
                <DocumentDataField id="supplierNumber" label={translate("documentData.supplierNumber")}
                                   value={details.supplierNumber}/>}
            <DocumentAmountField details={details} translate={translate}/>
            {!!details.employeeCode &&
                <DocumentDataField id="employeeCode" label={translate("documentData.employeeCode")}
                                   value={details.employeeCode}/>}
            {details.documentOrganizationUnit &&
                <DocumentDataField id="organizationUnit" label={translate("documentData.organizationUnit")}
                                   value={formatDocumentOrganizationUnit(details.documentOrganizationUnit)}/>}
        </DocumentDataGrid>

        {!!details.documentCostUnitList?.length &&
            <CostUnitsDetails costUnitList={details.documentCostUnitList} translate={translate}/>}
    </>
);

export default PurchaseOrderDocumentDetailsDTO;
